module.exports = __webpack_public_path__ + "static/img/成本-2.89b1ab21.png";